import { array } from "prop-types"
import { questionShape } from "source/registrations/propTypes"
import { Icon } from "source/shared/icons"

const QuestionText = ({ question, answers }) => {
  return (
    <div className="action-drawer mb-1">
      <div className="label d-f ai-c" style={{ gap: "0.5rem" }}>
        {question.question}
        {question.required && answers.length === 0 && (
          <Icon
            symbol="churchCenter#circle"
            className="fs-6"
            style={{ color: "var(--color-citrine)" }}
          />
        )}
      </div>
      {question.description && <div>{question.description}</div>}
      {answers.length ? <div>{answers.join(", ")}</div> : <>—</>}
    </div>
  )
}

QuestionText.propTypes = {
  question: questionShape,
  answers: array,
}

export default QuestionText
